<p-toast />
<form
  [formGroup]="formGroup"
  (ngSubmit)="nextStep()"
  class="w-full relative mt-3"
>
  <section class="personalInformation">
    <span
      *ngIf="!isRepresentative || (isRepresentative && currentStepIndex == 1)"
      class="titleSection"
      >Datos empresa</span
    >
    <div
      class="info-message p-2 my-2 legend"
      *ngIf="isRepresentative && currentStepIndex == 1"
    >
      <p class="text-justify text-sm m-0">
        <i class="pi pi-info-circle mr-1 text-sm"></i>
        Ingrese el CUIT para buscar automáticamente los datos de la empresa. Si
        no encontramos información, podrá completar los datos manualmente.
      </p>
    </div>

    <div class="grid w-full mb-2 mt-3">
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >{{ isRepresentative && currentStepIndex == 0 ? "CUIL" : "CUIT"
          }}<span class="span">*</span></label
        >
        <p-inputMask
          [readonly]="currentStepIndex == 0"
          class="inputLarge"
          mask="99-99999999-9"
          placeholder="99-99999999-9"
          formControlName="cuitCompany"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('cuitCompany', 'required')
          }"
          [style]="
            currentStepIndex == 0
              ? {
                  'background-color': 'rgb(223, 223, 223)',
                  border: 'none',
                  'box-shadow': 'none'
                }
              : {}
          "
          (onBlur)="
            isRepresentative && currentStepIndex == 1
              ? searchCompanyByCuit(formGroup.get('cuitCompany')?.value)
              : null
          "
        ></p-inputMask>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('cuitCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>

      <div
        *ngIf="!isRepresentative || currentStepIndex == 1"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle"
          >Razón social <span class="span">*</span></label
        >
        <input
          pInputText
          formControlName="razonSocial"
          placeholder="Razón social"
          maxlength="50"
          [class.disabled]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('razonSocial', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('razonSocial', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>

      <div
        *ngIf="isRepresentative && currentStepIndex == 0"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle">Nombre <span class="span">*</span></label>
        <input
          pInputText
          formControlName="representative_name"
          placeholder="Nombre"
          maxlength="50"
          [class.disabled]="isRepresentative && currentStepIndex == 0"
          [readonly]="isRepresentative && currentStepIndex == 0"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('representative_name', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('representative_name', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>

      <div
        *ngIf="isRepresentative && currentStepIndex == 0"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle">Apellido <span class="span">*</span></label>
        <input
          [class.disabled]="isRepresentative && currentStepIndex == 0"
          [readonly]="isRepresentative && currentStepIndex == 0"
          pInputText
          formControlName="representative_last_name"
          placeholder="Apellido"
          maxlength="50"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors(
              'representative_last_name',
              'required'
            )
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('representative_last_name', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Correo electronico<span class="span">*</span></label
        >
        <input
          [class.disabled]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0)
          "
          [readonly]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0)
          "
          placeholder="Correo electronico"
          type="text"
          pInputText
          formControlName="companyEmail"
          type="email"
          maxlength="100"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('companyEmail', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyEmail', 'required')"
        >
          Este campo es obligatorio
        </div>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyEmail', 'email')"
        >
          Formato de email incorrecto
        </div>
        <small
          class="block text-xs mt-1"
          *ngIf="isRepresentative && currentStepIndex == 1 && companyFound"
        >
          Si el correo es incorrecto, por favor escriba el correcto
        </small>
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Teléfono</label>
        <input
          [class.disabled]="
            !isRepresentative ||
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          placeholder="Teléfono"
          pInputText
          formControlName="companyPhone"
          maxlength="15"
          [appNumberOnlyNoLength]="15"
          [ngClass]="{
            'ng-invalid ng-dirty':
              hasErrors('companyPhone', 'minlength') ||
              hasErrors('companyPhone', 'maxlength')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyPhone', 'minlength')"
        >
          Este campo no puede poseer menos de 7 caracteres.
        </div>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('companyPhone', 'maxlength')"
        >
          Este campo no puede poseer más de 15 caracteres.
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Calle<span class="span">*</span></label>
        <input
          [class.disabled]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          placeholder="Calle"
          type="text"
          maxlength="50"
          pInputText
          formControlName="streetCompany"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('streetCompany', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('streetCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Número<span class="span">*</span></label>
        <input
          [class.disabled]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [appNumberOnlyNoLength]="15"
          placeholder="Número"
          type="text"
          pInputText
          formControlName="numberCompany"
          maxlength="5"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('numberCompany', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('numberCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Piso/Depto</label>
        <input
          [class.disabled]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          placeholder="Piso/Depto"
          type="text"
          pInputText
          formControlName="floorApartmentCompany"
          maxlength="10"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Torre</label>
        <input
          [class.disabled]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          placeholder="Torre"
          type="text"
          pInputText
          formControlName="towerCompany"
          maxlength="30"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Código postal<span class="span">*</span></label
        >
        <input
          [class.disabled]="
            !isRepresentative ||
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            !isRepresentative ||
            !isRepresentative ||
            (isRepresentative && currentStepIndex == 0) ||
            (isRepresentative && currentStepIndex == 1 && companyFound)
          "
          type="text"
          placeholder="Código postal"
          pInputText
          formControlName="postalCodeCompany"
          maxlength="10"
          [ngClass]="{
            'ng-invalid ng-dirty':
              hasErrors('postalCodeCompany', 'required') ||
              hasErrors('postalCodeCompany', 'maxlength') ||
              hasErrors('postalCodeCompany', 'minlength')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('postalCodeCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('postalCodeCompany', 'minlength')"
        >
          El campo solo acepta un máximo de 10 dígitos.
        </div>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('postalCodeCompany', 'minlength')"
        >
          El campo solo acepta un mínimo de 4 dígitos.
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle" for="claimetProvince" optionLabel="name"
          >Provincia<span class="span">*</span></label
        >
        <input
          *ngIf="
            currentStepIndex == 0 || (currentStepIndex == 1 && companyFound)
          "
          pInputText
          id="province_display"
          formControlName="provinceCompany"
          [class.disabled]="
            currentStepIndex == 0 || (currentStepIndex == 1 && companyFound)
          "
          [readonly]="
            currentStepIndex == 0 || (currentStepIndex == 1 && companyFound)
          "
        />
        <p-dropdown
          *ngIf="
            (currentStepIndex == 1 && !companyFound) || currentStepIndex > 1
          "
          id="claimetProvince"
          [options]="provinces"
          optionLabel="name"
          optionValue="id"
          placeholder="Seleccione su Provincia"
          formControlName="provinceCompany"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('provinceCompany', 'required')
          }"
        >
        </p-dropdown>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('provinceCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Localidad<span class="span">*</span></label>
        <input
          *ngIf="
            currentStepIndex == 0 || (currentStepIndex == 1 && companyFound)
          "
          pInputText
          id="city_display"
          formControlName="cityCompany"
          [readonly]="
            currentStepIndex == 0 || (currentStepIndex == 1 && companyFound)
          "
          [class.disabled]="
            currentStepIndex == 0 || (currentStepIndex == 1 && companyFound)
          "
        />
        <p-dropdown
          *ngIf="
            (currentStepIndex == 1 && !companyFound) || currentStepIndex > 1
          "
          [options]="localities"
          optionLabel="name"
          optionValue="name"
          [showClear]="false"
          placeholder="Seleccione su localidad"
          formControlName="cityCompany"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('cityCompany', 'required')
          }"
        >
        </p-dropdown>
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('cityCompany', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div
        *ngIf="!isRepresentative || (isRepresentative && currentStepIndex == 0)"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle"
          >Departamento laboral<span class="span">*</span></label
        >
        <p-dropdown
          [options]="departments"
          placeholder="Seleccione una opción"
          optionLabel="name"
          optionValue="id"
          formControlName="departmentId"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('departmentId', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('departmentId', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div
        *ngIf="!isRepresentative || (isRepresentative && currentStepIndex == 0)"
        class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6"
      >
        <label class="labelTitle">Persona<span class="span">*</span></label>
        <input
          placeholder="Cargo"
          formControlName="claimantTypePerformance"
          pInputText
          maxlength="50"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors(
              'claimantTypePerformance',
              'required'
            )
          }"
          [class.disabled]="currentStepIndex == 0"
          [readonly]="isRepresentative && currentStepIndex == 0"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('claimantTypePerformance', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
      <div
        *ngIf="isRepresentative && currentStepIndex == 1"
        class="grid w-full m-1"
      >
        <div class="col-12 md:col-3 lg:col-3 xl:col-12">
          <label class="text-sm font-bold mr-3"
            >Tipo de persona<span class="span"> *</span></label
          >
        </div>
        <div
          class="col-12 md:col-6 lg:col-6 xl:col-6 flex flex-column xl:flex-row md:flex-row lg:flex-row gap-1"
        >
          <div
            *ngFor="let person of typeOfPerson"
            class="flex align-items-center gap-1"
          >
            <p-radioButton
              [inputId]="person.key"
              [value]="person.name"
              formControlName="type_of_person"
            ></p-radioButton>
            <label
              [for]="person.key"
              class="ml-2 gap-1 mr-3 text-xs font-bold"
              >{{ person.name }}</label
            >
          </div>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('type_of_person', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>
      </div>
    </div>
  </section>

  <div
    *ngIf="currentStepIndex !== 1"
    class="grid w-full flex justify-content-end"
  >
    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        (click)="cancel()"
        label="Cancelar"
        class="btn-cancelar sm:text-xs"
      />
    </div>

    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        label="Siguiente"
        class="btn-siguiente"
        type="submit"
        [disabled]="formGroup.invalid"
      ></p-button>
    </div>
  </div>
</form>
